import { render, staticRenderFns } from "./CreateCredential.vue?vue&type=template&id=405a2b3a"
import script from "./CreateCredential.vue?vue&type=script&lang=js"
export * from "./CreateCredential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports